import { useMainLayoutProvider } from "@providers/MainLayoutProvider/useMainLayoutProvider";
import { useNavigate } from "react-router";

import { RecentUnresolvedNotificationsDropdown } from "@components/Dropdowns";
import { GlobalSearch } from "@components/GlobalSearch/GlobalSearch";

import { IconButton } from "@design-system/IconButton/IconButton";
import { AffireLogo } from "@design-system/AffireLogo/AffireLogo";
import { Clickable } from "@design-system/Clickable/Clickable";

import { useBreakpoint } from "@utils/hooks/useBreakpoint";
import { routes } from "@pages/routes";

import classes from "./MainHeader.module.css";

export const MainHeader = () => {
  const { isSmallerThan } = useBreakpoint();
  const { toggleMobileNavigation } = useMainLayoutProvider();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(routes.portal.dashboard.$path(), { viewTransition: true });
  };

  return (
    <header className={classes.header}>
      <div className={classes.left}>
        <Clickable onClick={handleLogoClick} outline="md">
          <AffireLogo />
        </Clickable>
        {isSmallerThan.laptop && (
          <IconButton icon="faBars" onClick={toggleMobileNavigation} />
        )}
      </div>

      <div className={classes.search}>
        <GlobalSearch />
      </div>

      <div className={classes.actions}>
        <RecentUnresolvedNotificationsDropdown count={20} />
      </div>
    </header>
  );
};
